'use client';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export function DocsCopyCode() {
  const pathname = usePathname();

  useEffect(() => {
    const blocks = document.querySelectorAll('.docs-prose pre');

    blocks.forEach(pre => {
      if (pre.querySelector('.docs-copy-btn')) return;

      (pre as HTMLElement).style.position = 'relative';

      const btn = document.createElement('button');
      btn.className = 'docs-copy-btn';
      btn.textContent = 'Copy';

      btn.addEventListener('click', () => {
        const code = pre.querySelector('code')?.innerText ?? pre.textContent ?? '';
        navigator.clipboard.writeText(code).then(
          () => {
            btn.textContent = 'Copied';
            btn.classList.add('docs-copy-btn--done');
            setTimeout(() => {
              btn.textContent = 'Copy';
              btn.classList.remove('docs-copy-btn--done');
            }, 2000);
          },
          () => { btn.textContent = 'Error'; setTimeout(() => { btn.textContent = 'Copy'; }, 2000); }
        );
      });

      pre.appendChild(btn);
    });
  }, [pathname]);

  return null;
}
